<template>
  <div id="app">
    <router-view/>
    <Footer></Footer>
  </div>
</template>

<script>
import Footer from '@/components/Footer'
export default {
  name: 'App',
  data() {
    return {
    }
  },
  components: {
    Footer
  }
}
</script>

<style lang="stylus" scoped>
@font-face{
    font-family: HelveticaLight;
    src: url('./assets/fonts/helvetica-light.otf')
}
@font-face{
    font-family: Helvetica;
    src: url('./assets/fonts/Helvetica.ttf')
}
@font-face{
    font-family: HelveticaBold;
    src: url('./assets/fonts/HelveticaBold.ttf')
}
[v-cloak]{ display:none}
#app {
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px; */
  .content {
    margin-top: .96rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue